/**
 * @generated SignedSource<<c57a82b7504feabfb1fb5426b0bdc833>>
 * @relayHash 95cf40a3352a7c712bb04484d8f73a12
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 74a3a18833d2c9dfca9436c24ca75e6630fcc3663cb8e7ff9b830b5c77e6d28e

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AppSelectorQuery$variables = Record<PropertyKey, never>;
export type AppSelectorQuery$data = {
  readonly me: {
    readonly user: {
      readonly accountId: string;
      readonly " $fragmentSpreads": FragmentRefs<"AppSelector_userDataFragment" | "StudioFoundationsApp_AtlassianStudioFoundations_userDataFragment">;
    };
  };
  readonly notifications: {
    readonly " $fragmentSpreads": FragmentRefs<"StudioFoundationsApp_AtlassianStudioFoundations_notificationDataFragment">;
  } | null | undefined;
};
export type AppSelectorQuery = {
  response: AppSelectorQuery$data;
  variables: AppSelectorQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "accountId"
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "AppSelectorQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "kind": "LinkedField",
              "name": "user",
              "plural": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": (v0/*: any*/),
                  "action": "THROW",
                  "path": "me.user.accountId"
                },
                {
                  "kind": "FragmentSpread",
                  "name": "AppSelector_userDataFragment"
                },
                {
                  "kind": "FragmentSpread",
                  "name": "StudioFoundationsApp_AtlassianStudioFoundations_userDataFragment"
                }
              ]
            },
            "action": "THROW",
            "path": "me.user"
          }
        ]
      },
      {
        "concreteType": "InfluentsNotificationQuery",
        "kind": "LinkedField",
        "name": "notifications",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "StudioFoundationsApp_AtlassianStudioFoundations_notificationDataFragment"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AppSelectorQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              (v0/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isUser"
              },
              {
                "kind": "ScalarField",
                "name": "name"
              },
              {
                "kind": "ScalarField",
                "name": "picture"
              },
              {
                "kind": "ScalarField",
                "name": "id"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "email"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "locale"
                  }
                ],
                "type": "AtlassianAccountUser"
              }
            ]
          }
        ]
      },
      {
        "concreteType": "InfluentsNotificationQuery",
        "kind": "LinkedField",
        "name": "notifications",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "unseenNotificationCount"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "74a3a18833d2c9dfca9436c24ca75e6630fcc3663cb8e7ff9b830b5c77e6d28e",
    "metadata": {},
    "name": "AppSelectorQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "677d8755f796192524d92c2de849ffff";

export default node;
